import {getCssSizeValue, getPropSafely} from "@/utils/utils";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";
import useHover from "@/hooks/useHover";
import {useEffect} from "react";

const StyledHeaderBar = styled.div`
	display: flex; 
	align-items: center;
    background: ${(props) => props.theme.colors.richBlue};
    color: ${(props) => props.theme.colors.antiflashWhite};
    padding: ${getCssSizeValue(10, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
	transition: all var(--rgr-duration) var(--ease);
    cursor: pointer;

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.TABLET)};
        padding: ${getCssSizeValue(24, BREAKPOINTS.TABLET)} ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
    }

    @media (min-width: ${({theme}) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
        margin-bottom: ${getCssSizeValue(16)};
        padding: ${getCssSizeValue(16)} ${getCssSizeValue(32)};
    }
	
	&.hover {
		background: ${(props) => props.theme.colors.periwinkle};
        color: ${(props) => props.theme.colors.richBlack};
	}
`

const HeaderContent = ({ data, hoveredId, setHoveredId, handleDownload}) => {
	const id = getPropSafely(data, 'id')
	const title = getPropSafely(data, 'title')
	const bigHeader = getPropSafely(data, 'bigHeader', false)
	const hoverClassName = hoveredId === id ? 'hover' : ''

	const [ref, hovering] = useHover({
		onMouseLeaveCallback: () => {
			setHoveredId(null)
		}
	})

	useEffect(() => {
		if (!hovering) return
		setHoveredId(id)
	}, [hovering]);

	return (
		<StyledHeaderBar
			ref={ref}
			className={`typo-strawford typo-strawford-65 ${hoverClassName} ${bigHeader ? 'big-header' : ''} col-mobile-8 col-tablet-4 col-desktop-4`}
			onClick={handleDownload}
		>
			{title}
		</StyledHeaderBar>
	)
}

export default HeaderContent